import { useEffect, useState } from 'react';
import config from '../../utils/apiUrl';

const useFetchFoundations = ({ company }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const columns = [
    {
      name: 'Nombre',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: 'Telefono',
      selector: (row) => row.contactPhone,
      sortable: true,
    },
    {
      name: 'Estado',
      selector: (row) => row.validation,
      sortable: true,
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${config.apiUrl}/company/admin/getFoundations?company=${company}`
      );
      if (!response.ok) {
        throw new Error('Error en la solicitud: ' + response.statusText);
      }
      const result = await response.json();
      setData(Array.isArray(result) ? result : result.foundations || []);
    } catch (err) {
      setError(err);
      console.error('⛔ Error en fetchData:', err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return { columns, data, loading, error, refetch: fetchData };
};

export default useFetchFoundations;
